import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output, Type, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig, FieldWrapper, FormlyFieldConfig, FormlyFieldProps, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgFor, NgIf } from '@angular/common';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { FormlyFieldInput } from '@ngx-formly/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { Istanza, IstanzeService } from 'app/services/istanze.service';

interface InputProps extends FormlyFieldProps { }

export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
  type: 'input' | Type<FormlyFieldInput>;
}

@Component({
  selector: 'star-rating',
  template: `
  <div class="h-full w-full bg-white p-6" *ngIf="(istanza?.numero_protocollo &&  !istanza?.stars) || !istanza">
     <div class="my-4">
      <div class="text-3xl font-semibold text-black">{{label}}</div>
    </div>
    <formly-form [model]="model" [fields]="fields" [form]="form"></formly-form>
  </div>`,
  styles: ` .mat-horizontal-stepper-header-container{
    display: none !important;
  } `,
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyModule, MatIconModule, MatProgressSpinnerModule, ReactiveFormsModule, MatTooltipModule, NgIf]
})
export class RatingTypeComponent extends FieldType<FieldTypeConfig<InputProps>> implements OnInit{

  private _istanzeService = inject(IstanzeService);

  @Input() istanza: Istanza
  label: string

  ngOnInit(): void {
    this._istanzeService.istanza$.subscribe(
      istanza=>{
        this.istanza=istanza;
        this.label = istanza?"Quanto è stato facile usare questo servizio?":"Quanto sono chiare le informazioni su questa pagina?"
      }
    )
  }

  fields: FormlyFieldConfig[] = [
    {
      key:'rating',
      type:'star-rating',
      props:{
        color:'primary',
      },
       expressions:{
        // 'props.readonly':  "model.indicazioni_3 || model.indicazioni_5",
        //'props.disabled': 'true' // Usa formState per controllare lo stato
       }

    },
    {
      type: 'stepper-rating',
      fieldGroup: [
        {
          props: { label: 'Dove hai riscontrato maggiori difficoltà?' },
          fieldGroup: [
            {
              key: 'indicazioni_3',
              type: 'radio',
              props: {
                color:'primary',
                label:'Dove hai incontrato le maggiori difficoltà?',
                options:[
                  {value:1, label:'A volte le indicazioni non erano chiare'},
                  {value:2, label:'A volte le indicazioni non erano complete'},
                  {value:3, label:'A volte non capivo se stavo procedendo correttamente'},
                  {value:4, label:'Ho avuto problemi tecnici'},
                  {value:5, label:'Altro'}
                ]
              },
              expressions:{
                hide: "!(model.rating <= 3)"
              }
            },
            {
              key: 'indicazioni_5',
              type: 'radio',
              props: {
                color:'primary',
                label:'Quali sono stati gli aspetti che hai preferito?',
                options:[
                  {value:1, label:'Le indicazioni erano chiare'},
                  {value:2, label:'Le indicazioni erano complete'},
                  {value:3, label:'Capivo sempre che stavo procedendo correttamente'},
                  {value:4, label:'Non ho avuto problemi tecnici'},
                  {value:5, label:'Altro'}
                ]
              },
              expressions:{
                hide: "!(model.rating > 3)"
              }
            },
          ],
        },
        {
          props: { label: 'Vuoi aggiungere altri dettagli?' },
          fieldGroup: [
            {
              className:'md:mt-8',
              key: 'dettaglio',
              type: 'textarea',
              props: {
                label: 'Vuoi aggiungere altri dettagli?',
                placeholder:'Dacci il tuo parere per aiutarci a migliorare la qualità del sito',
                "maxLength": 200,
                "autosize": true,
                "hintStart": 'Inserire massimo 200 caratteri',
                rows:3
              },
              "hooks": {
                "onInit": (field) => {
                  const control = field.formControl;
                  control.valueChanges.subscribe((value) => {
                    const currentValue = value || '';
                    field.props.hintEnd = `${currentValue.length} / 200 caratteri`;
                  });
                },
              },
            },
          ],
        },
        {
          props: { label: '' },
          fieldGroup: [
            {
              template:`<div class="text-2xl font-semibold"> Grazie, il tuo parere ci aiuterà a migliorare il servizio! </div>`
            },
          ],
        },
      ],
    },
  ];


}
